import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import ModalConfirmation from '../../../../../shared/ModalConfirmation/ModalConfirmation.jsx';

import { LIVE, DRAFT, REVIEW, CHOOSE } from '../../../utils/constants';
import { ScheduleButtonContainer } from '../ScheduleButtonContainer.jsx';

import MessageReviewModal from '../../Notifications/MessageReviewModal.jsx';

import {
  useUpdatePostMutation,
  useRevertPostMutation,
} from '../hooks/usePostMutation';
import { useCampaignContext } from '../../../contexts/CampaignContext.jsx';
import { NotificationsPanel } from '../../Notifications/NotificationsPanel.jsx';

export const NotificationsContainer = ({
  post,
  tiles,
  campaignId,
  campaignEndDate,
  setShowIncompleteBorder,
  setNoDateError,
}) => {
  const { t } = useTranslation('posts');
  const [messageModal, setMessageModal] = useState({
    singleStep: false,
    page: CHOOSE,
    open: false,
  });
  const [openCancelModal, setOpenCancelModal] = useState(false);

  const { updatePostMutation } = useUpdatePostMutation();
  const { revertPostMutation } = useRevertPostMutation();
  const { campaign } = useCampaignContext();
  const isDisabled = campaign.isArchived || !!campaign.deletedAt;

  const revertToDraft = () => {
    if (post.status === LIVE && !post.message) {
      revertPostMutation({ campaignId, id: post.uuid });
    } else {
      updatePostMutation({
        campaignId,
        id: post.uuid,
        status: DRAFT,
      });
    }

    setOpenCancelModal(false);
  };

  if (!tiles.length) return null;

  return (
    <>
      {/* Modal initializations */}
      <Dialog open={openCancelModal} onClose={() => setOpenCancelModal(false)}>
        <ModalWrapper>
          <ModalConfirmation
            header={t('postNotifications.cancelModal.header')}
            body={t('postNotifications.cancelModal.body')}
            cancelText={t('postNotifications.cancel')}
            submitText={t('postNotifications.cancelModal.submit')}
            variant="success"
            cancelMode="text"
            onSave={revertToDraft}
            onCancel={() => {
              setOpenCancelModal(false);
            }}
          />
        </ModalWrapper>
      </Dialog>
      {messageModal.open && (
        <MessageReviewModal
          key={post}
          messageModal={messageModal}
          closeModal={() => setMessageModal(false)}
          messageId={post.message?.uuid}
          campaignId={campaignId}
          post={post}
          endDate={campaignEndDate}
        />
      )}
      {/* Modal initializations */}

      {post.publishDate && post.message && (
        <NotificationsPanel post={post} setWizardModalMode={setMessageModal} />
      )}
      {!isDisabled && (
        <ScheduleButtonContainer
          post={post}
          tiles={tiles}
          setOpenScheduleModal={() => {
            if (!post.message) {
              setMessageModal({ open: true, singleStep: false, page: CHOOSE });
            } else {
              setMessageModal({ open: true, singleStep: true, page: REVIEW });
            }
          }}
          setOpenCancelModal={setOpenCancelModal}
          campaignId={campaignId}
          setShowIncompleteBorder={setShowIncompleteBorder}
          setNoDateError={setNoDateError}
        />
      )}
    </>
  );
};

const ModalWrapper = styled.div`
  padding: 20px;
`;
